import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import {  Grid, Link, InputLabel, Select, MenuItem, FormControl, Grid2 } from "@mui/material";

import { useState } from "react";
import firebase from 'firebase/compat/app';
import { collection, getCountFromServer, getFirestore, onSnapshot, getDocs, query, where } from '@firebase/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { doc, setDoc } from "firebase/firestore"; 
import Button from 'react-bootstrap/Button';
import { useEffect } from "react";
import { NumericStepper } from '@anatoliygatt/numeric-stepper';
import NumericInput from 'react-numeric-input';
import { Swiper, SwiperSlide } from "swiper/react";
import ModalListing from "./ModalListing";
import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import zipFromFipsJson from './zip_from_fips.json'; // wherever you save the JSON











export default function CountyModal({ onOpen, onClose, open, selectedCounty, selectedCountyID }) {


  const [value, setValue] = useState(0); 
  const [countyData, setCountyData] = useState(null); // State for API data
  const [loading, setLoading] = useState(false); // State for loading
  const [error, setError] = useState(null); // State for errors
  const [showMore, setShowMore] = useState(false);

  const [filter, setFilter] = useState("");
  const [zipCodeData, setZipCodeData] = useState(null);
  const [countyDataByZip, setCountyDataByZip] = useState([]);
  const [loading1, setLoading1] = useState(true);
  const [principle, setPrinciple] = useState(0);
  const [zipCode, setZipCode] = useState(null);

  // Filter rows based on zip code
  

  const handleToggle = () => {
    setShowMore((prev) => !prev);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const memphisData = [
    {
      "id": "38103",
      "zipCode": "38103",
      "saleData": {
          "lastUpdatedDate": "2025-01-20T00:00:00.000Z",
          "averagePrice": 423237,
          "medianPrice": 348500,
          "minPrice": 104900,
          "maxPrice": 2895000,
          "averagePricePerSquareFoot": 220.08,
          "medianPricePerSquareFoot": 209.55,
          "minPricePerSquareFoot": 209.55,
          "maxPricePerSquareFoot": 230.62,
          "averageSquareFootage": 3220,
          "medianSquareFootage": 2429,
          "minSquareFootage": 2429,
          "maxSquareFootage": 4011,
          "averageDaysOnMarket": 113.9,
          "medianDaysOnMarket": 104,
          "minDaysOnMarket": 3,
          "maxDaysOnMarket": 356,
          "newListings": 17,
          "totalListings": 181,
          "dataByPropertyType": [
              {
                  "propertyType": "Condo",
                  "averagePrice": 322544,
                  "medianPrice": 285000,
                  "minPrice": 104900,
                  "maxPrice": 1395000,
                  "averagePricePerSquareFoot": 209.55,
                  "medianPricePerSquareFoot": 209.55,
                  "minPricePerSquareFoot": 209.55,
                  "maxPricePerSquareFoot": 209.55,
                  "averageSquareFootage": 2429,
                  "medianSquareFootage": 2429,
                  "minSquareFootage": 2429,
                  "maxSquareFootage": 2429,
                  "averageDaysOnMarket": 115.57,
                  "medianDaysOnMarket": 104,
                  "minDaysOnMarket": 3,
                  "maxDaysOnMarket": 356,
                  "newListings": 11,
                  "totalListings": 111
              },
              {
                  "propertyType": "Single Family",
                  "averagePrice": 600611,
                  "medianPrice": 459000,
                  "minPrice": 104900,
                  "maxPrice": 2895000,
                  "averagePricePerSquareFoot": 230.62,
                  "medianPricePerSquareFoot": 230.62,
                  "minPricePerSquareFoot": 230.62,
                  "maxPricePerSquareFoot": 230.62,
                  "averageSquareFootage": 4011,
                  "medianSquareFootage": 4011,
                  "minSquareFootage": 4011,
                  "maxSquareFootage": 4011,
                  "averageDaysOnMarket": 110.23,
                  "medianDaysOnMarket": 96,
                  "minDaysOnMarket": 5,
                  "maxDaysOnMarket": 355,
                  "newListings": 5,
                  "totalListings": 63
              },
              {
                  "propertyType": "Townhouse",
                  "averagePrice": 423571,
                  "medianPrice": 435000,
                  "minPrice": 247500,
                  "maxPrice": 539000,
                  "averagePricePerSquareFoot": null,
                  "medianPricePerSquareFoot": null,
                  "minPricePerSquareFoot": null,
                  "maxPricePerSquareFoot": null,
                  "averageSquareFootage": null,
                  "medianSquareFootage": null,
                  "minSquareFootage": null,
                  "maxSquareFootage": null,
                  "averageDaysOnMarket": 120.86,
                  "medianDaysOnMarket": 114,
                  "minDaysOnMarket": 3,
                  "maxDaysOnMarket": 291,
                  "newListings": 1,
                  "totalListings": 7
              }
          ],
          "dataByBedrooms": [
              {
                  "bedrooms": 0,
                  "averagePrice": 115000,
                  "medianPrice": 115000,
                  "minPrice": 115000,
                  "maxPrice": 115000,
                  "averagePricePerSquareFoot": null,
                  "medianPricePerSquareFoot": null,
                  "minPricePerSquareFoot": null,
                  "maxPricePerSquareFoot": null,
                  "averageSquareFootage": null,
                  "medianSquareFootage": null,
                  "minSquareFootage": null,
                  "maxSquareFootage": null,
                  "averageDaysOnMarket": 73,
                  "medianDaysOnMarket": 73,
                  "minDaysOnMarket": 73,
                  "maxDaysOnMarket": 73,
                  "newListings": 0,
                  "totalListings": 1
              },
              {
                  "bedrooms": 1,
                  "averagePrice": 211827,
                  "medianPrice": 210000,
                  "minPrice": 104900,
                  "maxPrice": 424900,
                  "averagePricePerSquareFoot": null,
                  "medianPricePerSquareFoot": null,
                  "minPricePerSquareFoot": null,
                  "maxPricePerSquareFoot": null,
                  "averageSquareFootage": null,
                  "medianSquareFootage": null,
                  "minSquareFootage": null,
                  "maxSquareFootage": null,
                  "averageDaysOnMarket": 94.89,
                  "medianDaysOnMarket": 86,
                  "minDaysOnMarket": 4,
                  "maxDaysOnMarket": 275,
                  "newListings": 5,
                  "totalListings": 37
              },
              {
                  "bedrooms": 2,
                  "averagePrice": 344930,
                  "medianPrice": 319000,
                  "minPrice": 180000,
                  "maxPrice": 969000,
                  "averagePricePerSquareFoot": 209.55,
                  "medianPricePerSquareFoot": 209.55,
                  "minPricePerSquareFoot": 209.55,
                  "maxPricePerSquareFoot": 209.55,
                  "averageSquareFootage": 2429,
                  "medianSquareFootage": 2429,
                  "minSquareFootage": 2429,
                  "maxSquareFootage": 2429,
                  "averageDaysOnMarket": 125.3,
                  "medianDaysOnMarket": 116,
                  "minDaysOnMarket": 3,
                  "maxDaysOnMarket": 356,
                  "newListings": 7,
                  "totalListings": 74
              },
              {
                  "bedrooms": 3,
                  "averagePrice": 505730,
                  "medianPrice": 439999,
                  "minPrice": 265000,
                  "maxPrice": 1749000,
                  "averagePricePerSquareFoot": null,
                  "medianPricePerSquareFoot": null,
                  "minPricePerSquareFoot": null,
                  "maxPricePerSquareFoot": null,
                  "averageSquareFootage": null,
                  "medianSquareFootage": null,
                  "minSquareFootage": null,
                  "maxSquareFootage": null,
                  "averageDaysOnMarket": 113,
                  "medianDaysOnMarket": 97,
                  "minDaysOnMarket": 3,
                  "maxDaysOnMarket": 355,
                  "newListings": 3,
                  "totalListings": 42
              },
              {
                  "bedrooms": 4,
                  "averagePrice": 805037,
                  "medianPrice": 599000,
                  "minPrice": 348500,
                  "maxPrice": 2895000,
                  "averagePricePerSquareFoot": 230.62,
                  "medianPricePerSquareFoot": 230.62,
                  "minPricePerSquareFoot": 230.62,
                  "maxPricePerSquareFoot": 230.62,
                  "averageSquareFootage": 4011,
                  "medianSquareFootage": 4011,
                  "minSquareFootage": 4011,
                  "maxSquareFootage": 4011,
                  "averageDaysOnMarket": 117.75,
                  "medianDaysOnMarket": 103,
                  "minDaysOnMarket": 17,
                  "maxDaysOnMarket": 291,
                  "newListings": 1,
                  "totalListings": 24
              },
              {
                  "bedrooms": 5,
                  "averagePrice": 855667,
                  "medianPrice": 899000,
                  "minPrice": 468000,
                  "maxPrice": 1200000,
                  "averagePricePerSquareFoot": null,
                  "medianPricePerSquareFoot": null,
                  "minPricePerSquareFoot": null,
                  "maxPricePerSquareFoot": null,
                  "averageSquareFootage": null,
                  "medianSquareFootage": null,
                  "minSquareFootage": null,
                  "maxSquareFootage": null,
                  "averageDaysOnMarket": 73.33,
                  "medianDaysOnMarket": 80,
                  "minDaysOnMarket": 18,
                  "maxDaysOnMarket": 122,
                  "newListings": 1,
                  "totalListings": 3
              }
          ],
        }}
  ]

  console.log("SALEDATA", memphisData[0].saleData.medianPrice)
  
  const basicdata = countyData?.data?.basicdata
  ? Array.isArray(countyData.data.basicdata)
    ? countyData.data.basicdata
    : [countyData.data.basicdata] // Wrap the object in an array
  : null;


    const filteredData = basicdata
    ? basicdata.filter((row) =>
        row.zip_code && row.zip_code.toString().includes(filter)
      )
    : [];

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    borderRadius:3,
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    maxHeight: '100vh',
    p: 4,
    overflowY: "auto"

  };
  

  /**
 * Given a 5-digit county FIPS, returns *one* ZIP in that county
 */
/**
 * Given a 5-digit county FIPS and its human-readable name (e.g. "Shelby County"),
 * return one ZIP in that county via the Zippopotam.us API.
 */
function getZipFromCountyFips(countyFips) {
  const entries = zipFromFipsJson.filter(item => item.COUNTY === parseInt(countyFips));
  if (!entries.length) return null;

  // Get ZIP with highest residential ratio
  const best = entries.reduce((prev, curr) =>
    curr.RES_RATIO > prev.RES_RATIO ? curr : prev
  );
  return String(best.ZIP).padStart(5, '0'); // Return ZIP as 5-digit string
}


useEffect(() => {
  if (!selectedCountyID || !open) return;

  setLoading(true);
  setError(null);

  try {
    const zip = getZipFromCountyFips(selectedCountyID);
    if (!zip) throw new Error("No ZIP found for that county");
    setZipCodeData(zip);
  } catch (err) {
    setError(err.message);
  } finally {
    setLoading(false);
  }
}, [selectedCountyID, open]);

  const fetchCountyDataByZip = async () => {
    try {
      const response = await fetch(
        `https://api.rentcast.io/v1/markets?zipCode=${zipCodeData}&dataType=All&historyRange=6`,
        {
          headers: {
            'X-API-Key': '3bf99588906842468bdd81d2e38d0083',
          },
        }
      );
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json();
      setCountyDataByZip(data); // Update the state with the API response
      console.log("COUNTY DATA BY ZIP CODE!!!",countyDataByZip)
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading1(false);
    }
  };
  
  useEffect(() => {
    fetchCountyDataByZip();
  }, [zipCodeData]); 



  useEffect(() => {
    if (!selectedCounty || !open) return; // Do nothing if modal is not open or no county selected
    
    const fetchCountyData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(
          `https://www.huduser.gov/hudapi/public/fmr/data/${selectedCountyID}99999`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI2IiwianRpIjoiMDVkNDlhYzVjMjM2OGI2YjNmZTBjNzA0Njg1ZmMyOTk2YzMxMDlkZWU0MmFiMmI5MjE2NGZlOGY1NmNhYjIzYzM2ZWZkMzBhZDBlNDhjY2YiLCJpYXQiOjE3MzY2MzkzOTQuMDkzNjkxLCJuYmYiOjE3MzY2MzkzOTQuMDkzNjkzLCJleHAiOjIwNTIxNzIxOTQuMDg5MzQ4LCJzdWIiOiI4NDkyNyIsInNjb3BlcyI6W119.i07PAw5rSJ3ttVmU1pEOZOw9DJKEBgaSQVVLFcR7Yn9gRjnPHXXeLaVU9yWQZli4IX5YS58kOzbfcc-NI7yMPQ`,
            },
          }
        );
        if (!response.ok) {
          throw new Error(`Failed to fetch data for ${selectedCounty}`);
        }
        const data = await response.json();
        setCountyData(data); // Update state with the fetched data
        console.log("COUNTY DATA ------->",countyData)
      } catch (err) {
        setError(err.message); // Handle errors
      } finally {
        setLoading(false); // Turn off loading spinner
      }
    };

    fetchCountyData();
  }, [selectedCounty, open]);
  
console.log(countyData)

useEffect(() => {
  if (countyDataByZip?.saleData?.medianPrice != null) {
    const calculatedP = countyDataByZip.saleData.medianPrice * 0.8;
    setPrinciple(calculatedP);
  }
}, [countyDataByZip]);

var M; //monthly mortgage payment
var P = principle
var I = 6.5 / 100 / 12; //monthly interest rate
var N = 30 * 12; //number of payments months  

function monthlyPayment(p, n, i) {
  return p * i * (Math.pow(1 + i, n)) / (Math.pow(1 + i, n) - 1);
}

M = monthlyPayment(P, N, I);

const bedrooms = countyDataByZip?.saleData?.dataByBedrooms;

// safely grab each bedroom‐price (or null if missing)
const avg1Br = bedrooms?.[1]?.averagePrice ?? null;
const avg2Br = bedrooms?.[2]?.averagePrice ?? null;
const avg3Br = bedrooms?.[3]?.averagePrice ?? null;
const avg4Br = bedrooms?.[3]?.averagePrice ?? null;

  if (countyData !== null) {
    return (
      <div>
        <Modal
          open={open}
          onClose={onClose}
          
        >
          <Box sx={style}>
          {/* <SwiperSlide >
              <img
                src={"https://i.ibb.co/xKby3CK/abandoned-old-wood-plank-farm-house-very-bad-condition-149482664.webp"}
                alt={"house"}
                className="swiper-image"
              />
            </SwiperSlide> */}
           
          
          <Typography align="center"   variant="h5" component="h4">
          {countyData.data.county_name}
             </Typography>
          <Typography align="center"   variant="h6" component="h4">
          {countyData.data.metro_name}
             </Typography>
          <Typography align="center"   variant="h5" component="h4">
          {countyData.data.basicdata.year}
             </Typography>
          <Typography align="center"   variant="h5" component="h4">
          {countyData.data.year}
             </Typography>
          
          <Grid container rowSpacing={8} spacing={{ xs: 4, md: 4 }} columns={{ xs: 4, sm: 8, md: 12 }} >
             
              <Grid item xs={2} sm={4} md={4}>
              <Typography id="modal-modal-title" variant="h6" component="h4" >
                <h4 align={'center'}>Median Price</h4>
                <div align="center">
  {countyDataByZip?.saleData?.medianPrice ? (
    <Chip
    label={`$${Number(countyDataByZip.saleData.medianPrice).toLocaleString()}`}
  />
  ) : (
    <span>Loading...</span> // Or any placeholder you'd like
  )}
</div>
  
            </Typography>
            <Grid item xs={2} sx={{mb:4}} align={'center'} >
              {/* <NumericInput mobile  min={0} max={1000000} value={137.8} step={0.1} precision={2}/> */}
              </Grid>
              <Typography id="modal-modal-title" variant="h6" component="h4" >
                <h4 align={'center'}>FMR to Price</h4>
                <div align="center">
                {countyDataByZip?.saleData?.medianPrice && basicdata?.[0]?.["One-Bedroom"] ? (
  <Chip
    label={`${(countyDataByZip.saleData.medianPrice/ basicdata[0]["One-Bedroom"]).toFixed(1)}x`}
  />
) : (
  <Chip label="Loading..." />
)}                </div>
  
            </Typography>
              
            <Grid item xs={2} sx={{mb:4}} align={'center'} >
              {/* <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/> */}
              </Grid>
              
              
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
              <Typography id="modal-modal-title" variant="h6" component="h4" >
                <h4 align={'center'}>Total Listings</h4>
                <div align="center">
                {countyDataByZip?.saleData?.totalListings ? (
  
  <Chip label={`${countyDataByZip.saleData.totalListings}`} />
  
) : (
  <Chip label="Loading..." />
)}             
                </div>
  
            </Typography>
            <Grid item xs={2} align={'center'}sx={{mb:4}}>
              {/* <NumericInput mobile  min={0} max={10000000} value={158.42} step={0.1} precision={2}/> */}
              </Grid>
              <Typography id="modal-modal-title" variant="h6" component="h4" >
                <h4 align={'center'}>New Listings</h4>
                <div align="center">
                {countyDataByZip?.saleData?.newListings ? (
  
  <Chip label={`${countyDataByZip.saleData.newListings}`} />
  
) : (
  <Chip label="Loading..." />
)}                           </div>
                <div align="center">

                { !showMore && <Button
            variant="contained"
            onClick={handleToggle}
            style={{
              backgroundColor: "#1976d2",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
              marginTop:'20px',
              padding: "10px 20px",
              borderRadius: "30px",
              textTransform: "none",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "#155a9a",
                boxShadow: "0 6px 8px rgba(0, 0, 0, 0.2)",
              },
            }}
          >
            
            Show More
          </Button>}
      </div>
  
            </Typography>
            <Grid item xs={2} align={'center'} sx={{mb:4}}>
              {/* <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/> */}
              </Grid>
              
             
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
              <Typography id="modal-modal-title" variant="h6" component="h4" >
                <h4 align={'center'}>Avg Listing Age</h4>
                <div align="center">
                {countyDataByZip?.saleData?.averageDaysOnMarket ? (
  
  <Chip label={`${countyDataByZip.saleData.averageDaysOnMarket}`} />
  
) : (
  <Chip label="Loading..." />
)}     
                </div>
  
            </Typography>
            <Grid item xs={2} align={'center'} sx={{mb:4}}>
              {/* <NumericInput mobile  min={0} max={10000000} value={75} step={0.1} precision={2}/> */}
              </Grid>
              <Typography id="modal-modal-title" variant="h6" component="h4" >
                <h4 align={'center'}>Est Avg Mortgage</h4>
                <div align="center">
                <Chip
  label={`$${Number(M).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`}
/>                </div>
  
            </Typography>
            <Grid  >
              {/* <NumericInput mobile  min={0} max={1111000} value={0} step={0.1} precision={2}/> */}
              </Grid>
              
              </Grid>
          
                
              
            </Grid>


            {showMore &&
            
            <Grid container rowSpacing={8} spacing={{ xs: 4, md: 4 }} columns={{ xs: 4, sm: 8, md: 12 }} >
             
              <Grid item xs={2} sm={4} md={4}>
              <Typography id="modal-modal-title" variant="h6" component="h4" >
                <h4 align={'center'}>Avg. SQFT</h4>
                <div align="center">
                {countyDataByZip?.saleData?.averageSquareFootage ? (
  
  <Chip label={`${countyDataByZip.saleData.averageSquareFootage}`} />
  
) : (
  <Chip label="Loading..." />
)}           
                
                </div>
  
            </Typography>
            <Grid item xs={2} sx={{mb:4}} align={'center'} >
              {/* <NumericInput mobile  min={0} max={1000000} value={137.8} step={0.1} precision={2}/> */}
              </Grid>
              <Typography id="modal-modal-title" variant="h6" component="h4" >
              <h4 align={'center'}>Avg. 2br Price</h4>
                <div align="center">
      {avg2Br != null ? (
        <Chip label={`$${Number(avg2Br).toLocaleString()}`} />
      ) : (
        <Chip label="N/A" />
      )}
    </div>
  
            </Typography>
              
            <Grid item xs={2} sx={{mb:4}} align={'center'} >
              {/* <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/> */}
              </Grid>
              
              
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
              <Typography id="modal-modal-title" variant="h6" component="h4" >
                <h4 align={'center'}>Price / SQFT</h4>
                <div align="center">
                {countyDataByZip?.saleData?.averagePricePerSquareFoot ? (
  
<Chip
  label={`$${Number(countyDataByZip.saleData.averagePricePerSquareFoot).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`}
/>
  
) : (
  <Chip label="Loading..." />
)}      
                </div>
  
            </Typography>
            <Grid item xs={2} align={'center'}sx={{mb:4}}>
              {/* <NumericInput mobile  min={0} max={10000000} value={158.42} step={0.1} precision={2}/> */}
              </Grid>
              <Typography id="modal-modal-title" variant="h6" component="h4" >
                <h4 align={'center'}>Avg. 3br Price</h4>
                <div align="center">
      {avg3Br != null ? (
        <Chip label={`$${Number(avg3Br).toLocaleString()}`} />
      ) : (
        <Chip label="N/A" />
      )}
    </div>
                <div align="center">

                <Button
            variant="contained"
            onClick={handleToggle}
            style={{
              backgroundColor: "#1976d2",
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
              marginTop:'20px',
              padding: "10px 20px",
              borderRadius: "30px",
              textTransform: "none",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "#155a9a",
                boxShadow: "0 6px 8px rgba(0, 0, 0, 0.2)",
              },
            }}
          >
            
            
            Show Less
          </Button>
          </div>
                
                
  
            </Typography>
            
                
           
            <Grid item xs={2} align={'center'} sx={{mb:4}}>
              {/* <NumericInput mobile  min={0} max={10000000} value={0} step={0.1} precision={2}/> */}
              </Grid>
              
             
              </Grid>
              <Grid item xs={2} sm={4} md={4}>
              <Typography id="modal-modal-title" variant="h6" component="h4" >
                <h4 align={'center'}>Avg 1br Price</h4>
               <div align="center">
      {avg1Br != null ? (
        <Chip label={`$${Number(avg1Br).toLocaleString()}`} />
      ) : (
        <Chip label="N/A" />
      )}
    </div>
  
            </Typography>
            <Grid item xs={2} align={'center'} sx={{mb:4}}>
              {/* <NumericInput mobile  min={0} max={10000000} value={75} step={0.1} precision={2}/> */}
              </Grid>
              <Typography id="modal-modal-title" variant="h6" component="h4" >
              <h4 align={'center'}>Avg. 4br Price</h4>
                <div align="center">
      {avg4Br != null ? (
        <Chip label={`$${Number(avg4Br).toLocaleString()}`} />
      ) : (
        <Chip label="N/A" />
      )}
    </div>
  
            </Typography>
            <Grid  >
              {/* <NumericInput mobile  min={0} max={1111000} value={0} step={0.1} precision={2}/> */}
              </Grid>
              
              </Grid>
          
                
              
            </Grid>
            
            }
            <Grid container >
            <Grid  >
            


            {
              !Array.isArray(basicdata) || basicdata.length === 0 ?
              <div>No Data Available</div> :
              <TableContainer style = {{    height: '500px', 
              }} component={Paper}>



<div>
      {/* Filter Input */}
      {Array.isArray(countyData.data.basicdata) && 
       <div style={{ marginBottom: "20px" }}>
      
        <input
          type="text"
          id="zipFilter"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          placeholder="Enter Zip Code"
          style={{
            padding: "8px",
            borderRadius: "8px",
            border: "1px solid #ccc",
            fontSize: "1em",
            marginBottom:'-20px',
            width: '200px'
          }}
        />
      </div> 
      
      
      
      
      }
      

      {/* Table */}
      <Table aria-label="customized table" maxHeight="300px">
        <TableHead>
          <TableRow>
            <StyledTableCell>Zip Code</StyledTableCell>
            <StyledTableCell align="right">Efficiency</StyledTableCell>
            <StyledTableCell align="right">One-Bedroom</StyledTableCell>
            <StyledTableCell align="right">Two-Bedroom</StyledTableCell>
            <StyledTableCell align="right">Three-Bedroom</StyledTableCell>
            <StyledTableCell align="right">Four-Bedroom</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {       Array.isArray(countyData.data.basicdata) ?
          filteredData.map((row, index) => (
            <StyledTableRow key={row.zip_code}>
              <StyledTableCell component="th" scope="row">
                {row.zip_code}
              </StyledTableCell>
              <StyledTableCell align="right">${row.Efficiency}</StyledTableCell>
              <StyledTableCell align="right">
                ${row["One-Bedroom"]}
              </StyledTableCell>
              <StyledTableCell align="right">
                ${row["Two-Bedroom"]}
              </StyledTableCell>
              <StyledTableCell align="right">
                ${row["Three-Bedroom"]}
              </StyledTableCell>
              <StyledTableCell align="right">
                ${row["Four-Bedroom"]}
              </StyledTableCell>
            </StyledTableRow>
          )) :
          basicdata.map((row, index) => (
            <StyledTableRow key={row.zip_code}>
              <StyledTableCell component="th" scope="row">
                {row.zip_code}
              </StyledTableCell>
              <StyledTableCell align="right">${row.Efficiency}</StyledTableCell>
              <StyledTableCell align="right">
                ${row["One-Bedroom"]}
              </StyledTableCell>
              <StyledTableCell align="right">
                ${row["Two-Bedroom"]}
              </StyledTableCell>
              <StyledTableCell align="right">
                ${row["Three-Bedroom"]}
              </StyledTableCell>
              <StyledTableCell align="right">
                ${row["Four-Bedroom"]}
              </StyledTableCell>
            </StyledTableRow>
          ))

          }


      
      
        </TableBody>
      </Table>
    </div>


        
      </TableContainer >






            }

            





              </Grid>
            <Grid item xs={6} align={'left'} >
            
              </Grid>
             
            
      
              
              </Grid>
              
              
              
              
            
  
            
          
          </Box>
  
          {/* <Typography>
  
          <h1>Hi</h1>
          </Typography> */}
          
         
        
          
        </Modal>
      </div>
    );
  }
  
}

const headerStyle = {
  border: "1px solid #ddd",
  padding: "8px",
  textAlign: "center",
  backgroundColor: "#f2f2f2",
  fontWeight: "bold",
};